import IconButton from '@components/IconButton/IconButton';
import Text from '@components/Text/Text';
import { Drawer, useTheme } from '@mui/material';
import { useMediaQueries } from '@utils/mediaQueries/mediaQueries';
import React from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import { SlidingPanelProps } from './SlidingPanel.types';
import {
  StyledLogo,
  StyledSlidingTopContainer,
  StyledLogoContainer,
} from './SlidingPanel.styles';

const SlidingPanel: React.FC<SlidingPanelProps> = ({
  children,
  anchor,
  title,
  image,
  showCloseButton = true,
  PaperProps,
  ...restProps
}) => {
  const { sm: isMobile } = useMediaQueries();
  const theme = useTheme();
  return (
    <React.Fragment>
      <Drawer
        PaperProps={{
          ...PaperProps,
          sx: {
            height: isMobile ? 'calc(100vh - 10px)' : '100vh',
            borderTopLeftRadius: isMobile ? theme.spacing(10) : 0,
            borderTopRightRadius: isMobile ? theme.spacing(10) : 0,
            padding: isMobile ? theme.spacing(16, 8) : theme.spacing(15),
            ...PaperProps?.sx,
            [theme.breakpoints.down('sm')]: {
              width: '100%',
            },
          },
        }}
        anchor={isMobile ? 'bottom' : anchor}
        aria-label={title}
        {...restProps}
      >
        <StyledSlidingTopContainer>
          {image && (
            <StyledLogoContainer>
              <StyledLogo alt='slider-header-image' src={image} />
            </StyledLogoContainer>
          )}
          <Text
            variant='h5'
            fontWeight='fontWeightSemiBold'
            color={theme.palette.black.A100}
            flex={1}
          >
            {title}
          </Text>
          {showCloseButton && (
            <IconButton
              data-testid='slider-close-button'
              onClick={(event) =>
                restProps?.onClose && restProps.onClose(event, 'escapeKeyDown')
              }
              size='small'
              iconBoxHeight={25}
              iconBoxWidth={25}
              icon={() => <CancelIcon color='info' />}
            />
          )}
        </StyledSlidingTopContainer>
        {children}
      </Drawer>
    </React.Fragment>
  );
};

export default SlidingPanel;
